<template>
    <div class="apprentice-simple-card school-address-settings">
        <p class="description">
            {{ $t('school.the_data_below_is_used_among_other_things_to_export_the_yearbook_and_magazine_things') }}
        </p>

        <div class="row">
            <div class="col-12 col-md-8 col-xl-6">
                <div class="school-address-setting">
                    <b-alert
                        v-if="errorsFound"
                        variant="danger"
                        show>
                        Je hebt niet alle verplichte velden correct ingevuld.
                    </b-alert>

                    <b-form-group
                        class="school-id"
                        label-for="school-id-input"
                        label="ID / UUID">
                        <div class="id">{{ schoolIn.id }} / {{ schoolIn.uuid }}</div>
                    </b-form-group>
                    <b-form-group
                        class="school-name"
                        label-for="school-name-input">
                        <template #label> {{ $t('common.name') }}: <span class="required">*</span> </template>
                        <b-form-input
                            id="school-name-input"
                            v-model="name"
                            :placeholder="$t('school.school_name')">
                        </b-form-input>
                    </b-form-group>
                    <b-form-group
                        class="school-street"
                        label-for="school-street-input">
                        <template #label> {{ $t('common.street') }}: <span class="required">*</span> </template>
                        <b-form-input
                            id="school-street-input"
                            v-model="street"
                            :placeholder="$t('common.street')">
                        </b-form-input>
                    </b-form-group>
                    <b-form-group
                        class="school-number"
                        label-for="school-number-input">
                        <template #label> {{ $t('common.house_number') }}: <span class="required">*</span> </template>
                        <b-form-input
                            id="school-number-input"
                            v-model="streetnumber"
                            :placeholder="$t('common.house_number')">
                        </b-form-input>
                    </b-form-group>
                    <b-form-group
                        class="school-place"
                        label-for="school-place-input">
                        <template #label> {{ $t('common.postal_code') }}: <span class="required">*</span> </template>
                        <b-form-input
                            id="school-place-input"
                            v-model="zipcode"
                            :placeholder="$t('common.postal_code')">
                        </b-form-input>
                    </b-form-group>
                    <b-form-group
                        class="school-city"
                        label-for="school-city-input">
                        <template #label> {{ $t('common.city') }}: <span class="required">*</span> </template>
                        <b-form-input
                            id="school-city-input"
                            v-model="city"
                            :placeholder="$t('common.city')">
                        </b-form-input>
                    </b-form-group>
                    <b-form-group
                        class="school-phone"
                        label-for="school-phone-input"
                        :label="$t('common.phone')">
                        <b-form-input
                            id="school-phone-input"
                            v-model="phone"
                            :placeholder="$t('common.phone')">
                        </b-form-input>
                    </b-form-group>

                    <b-button
                        class="btn-save btn-save-school-settings"
                        variant="primary"
                        @click="save()">
                        {{ $t('common.phone') }}
                    </b-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'design-2021-school-settings-address-component',
    props: ['schoolIn'],
    data() {
        return {
            name: this.schoolIn.name,
            street: this.schoolIn.street,
            streetnumber: this.schoolIn.streetnumber,
            zipcode: this.schoolIn.zipcode,
            city: this.schoolIn.city,
            phone: this.schoolIn.phone,
            errorsFound: false,
        };
    },
    methods: {
        save() {
            if (this.hasErrors()) {
                this.errorsFound = true;
                return;
            }

            let data = {
                name: this.name,
                street: this.street,
                streetnumber: this.streetnumber,
                zipcode: this.zipcode,
                city: this.city,
                phone: this.phone,
            };

            this.alert.saving();

            this.axios.post(this.routes.addressUpdate(), data).then(
                (response) => {
                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },

        hasErrors() {
            this.errorsFound =
                this.name === undefined ||
                this.name === '' ||
                this.street === undefined ||
                this.street === '' ||
                this.streetnumber === undefined ||
                this.streetnumber === '' ||
                this.zipcode === undefined ||
                this.zipcode === '' ||
                this.city === undefined ||
                this.city === '';

            return this.errorsFound;
        },
    },
};
</script>

<style scoped lang="scss">
.school-address-settings {
    .description {
        margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');
    }

    .id {
        font-weight: $font-weight-bold;
    }
}
</style>
